import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__color } from '@shared/dto/+image/image_asset_base/DTO__color';

declare global {
  interface OffscreenCanvas {
    is_zero_size(): boolean;

    is_has_any_pixel_of(color: DTO__color): boolean;

    is_has_any_other_pixel_than(color: DTO__color): boolean;
  }
}

OffscreenCanvas.prototype.is_zero_size = function (): boolean {
  return this.width == 0 || this.height == 0;
};

OffscreenCanvas.prototype.is_has_any_pixel_of = function (color: DTO__color): boolean {
  let out = false;

  const context = this.getContext('2d');
  assert_not_null(context);

  const { width, height } = this;
  const image_data: ImageData = context.getImageData(0, 0, width, height);
  const data = image_data.data;

  for (let i = 0; i < data.length; i += 4) {
    const [r, g, b, _] = [data[i], data[i + 1], data[i + 2], data[i + 3]];

    if (r === color.r && g === color.g && b === color.b) {
      out = true;
      break;
    }
  }

  return out;
};

OffscreenCanvas.prototype.is_has_any_other_pixel_than = function (color: DTO__color): boolean {
  let out = false;

  const context = this.getContext('2d');
  assert_not_null(context);

  const { width, height } = this;
  const image_data: ImageData = context.getImageData(0, 0, width, height);
  const data = image_data.data;

  for (let i = 0; i < data.length; i += 4) {
    const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];

    if (r !== color.r || g !== color.g || b !== color.b) {
      out = true;
      break;
    }
  }

  return out;
};

export {}; // This ensures TypeScript treats it as a module
